import type { LivePlaylistItem } from "@tih/shared";
import { StreamThumbnail } from "./StreamThumbnail";

type Props = {
  title: string;
  items: LivePlaylistItem[];
  activeEventId: number | null;
  onSelect: (item: LivePlaylistItem) => void;
};

function formatReplayDate(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function LiveReplayPlaylist({ title, items, activeEventId, onSelect }: Props) {
  if (items.length === 0) return null;

  return (
    <aside className="live-playlist" aria-label={title}>
      <h2 className="live-playlist-title">{title}</h2>
      <ol className="live-playlist-list">
        {items.map((item) => {
          const active = item.eventId === activeEventId;
          return (
            <li key={item.eventId}>
              <button
                type="button"
                className={`live-playlist-item${active ? " is-active" : ""}`}
                onClick={() => onSelect(item)}
                aria-current={active ? "true" : undefined}
              >
                <span className="live-playlist-thumb">
                  <StreamThumbnail
                    stream={{
                      source: item.source,
                      youtubeId: item.youtubeId,
                      title: item.title,
                      subtitle: item.subtitle,
                    }}
                    posterUrl={item.posterUrl}
                  />
                </span>
                <span className="live-playlist-copy">
                  <span className="live-playlist-item-title">{item.title}</span>
                  <span className="live-playlist-item-date">
                    {formatReplayDate(item.streamedAt)}
                  </span>
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </aside>
  );
}
